
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Share2, Copy, Twitter, Facebook } from "lucide-react";
import { Profile } from "@/hooks/useProfile";
import { toast } from "sonner";

interface ShareProfileSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  profile?: Profile;
}

export const ShareProfileSheet = ({ open, onOpenChange, profile }: ShareProfileSheetProps) => {
  const profileUrl = `${window.location.origin}/profile/${profile?.username || profile?.user_id}`;

  const handleCopyLink = () => {
    navigator.clipboard.writeText(profileUrl);
    toast.success("Profile link copied to clipboard!");
  };

  const handleShareTwitter = () => {
    const text = `Check out ${profile?.farm_name || 'this farm'} on Farmlink!`;
    window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(profileUrl)}`, '_blank');
  };

  const handleShareFacebook = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(profileUrl)}`, '_blank');
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent>
        <SheetHeader>
          <SheetTitle className="flex items-center gap-2">
            <Share2 size={20} />
            Share Profile
          </SheetTitle>
        </SheetHeader>
        
        <div className="space-y-4 mt-6">
          <div className="p-4 bg-gray-50 rounded-lg">
            <h3 className="font-medium text-gray-900 mb-2">
              {profile?.farm_name || 'Farm Profile'}
            </h3>
            <p className="text-sm text-gray-600 mb-3">
              Share this farm profile with others to connect and collaborate.
            </p>
            <div className="text-xs text-gray-500 bg-white p-2 rounded border break-all">
              {profileUrl}
            </div>
          </div>

          <div className="space-y-2">
            <Button onClick={handleCopyLink} className="w-full" variant="outline">
              <Copy size={16} className="mr-2" />
              Copy Link
            </Button>
            
            <Button onClick={handleShareTwitter} className="w-full" variant="outline">
              <Twitter size={16} className="mr-2" />
              Share on Twitter
            </Button>
            
            <Button onClick={handleShareFacebook} className="w-full" variant="outline">
              <Facebook size={16} className="mr-2" />
              Share on Facebook
            </Button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};
